import React from "react";

const HRDVPricing = ({ title, descriptionMain, rateRows, descriptionNote }) => {
  return (
    <section className="hrdv-pricing-section">
      <div className="container">
        <h2
          className="hrdv-pricing-title text-center"
          data-aos="fade-up"
          data-aos-once="true"
        >
          {title}
        </h2>

        <p
          className="hrdv-pricing-main"
          data-aos="fade-up"
          data-aos-delay="100"
          data-aos-once="true"
        >
          {descriptionMain}
        </p>

        <div
          className="table-responsive"
          data-aos="fade-up"
          data-aos-delay="150"
          data-aos-once="true"
        >
          <table className="hrdv-pricing-table">
            <thead>
              <tr>
                <th>Rental Duration</th>
                <th>Without Driver</th>
                <th>With Driver</th>
              </tr>
            </thead>
            <tbody>
              {rateRows.map((row, i) => (
                <tr key={i}>
                  <td><strong>{row.duration}</strong></td>
                  <td>{row.withoutDriver}</td>
                  <td>{row.withDriver}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div
          className="hrdv-pricing-note-box"
          data-aos="fade-up"
          data-aos-delay="200"
          data-aos-once="true"
        >
          <p>{descriptionNote}</p>
        </div>

        <div
          className="hrdv-pricing-actions"
          data-aos="fade-up"
          data-aos-delay="300"
          data-aos-once="true"
        >
          <a href="tel:+971544792905" className="mini-btn primary">
            Call Now
          </a>
          <a
            href="https://wa.me/971544792905"
            target="_blank"
            rel="noopener noreferrer"
            className="mini-btn secondary-dark"
          >
            WhatsApp Now
          </a>
        </div>
      </div>
    </section>
  );
};

export default HRDVPricing;
